import { createContext, useContext } from 'react'

import { type AgentPanelState, useAgentPanelState } from '../AgentChat/useAgentPanelState'

const AskCaiContext = createContext<AgentPanelState | null>(null)

/**
 * Panel state for Ask Cai, held above the router `Outlet` in `AppLayout` so the
 * chat — and the thread it has open — survives customers navigating the app.
 * Its own sessionStorage keys, so a staff member using both panels doesn't have
 * one steal the other's open thread.
 */
export function AskCaiProvider({ children }: { children: React.ReactNode }) {
  const value = useAgentPanelState('askCai')
  return <AskCaiContext.Provider value={value}>{children}</AskCaiContext.Provider>
}

export function useAskCaiPanel(): AgentPanelState {
  const ctx = useContext(AskCaiContext)
  if (!ctx) throw new Error('useAskCaiPanel must be used inside an AskCaiProvider')
  return ctx
}
